/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'util/PropTypes';
import StringResources from 'nls/StringResources';
import { ContextMenu } from 'ca-ui-toolkit';
import { CaretToolbarItem } from 'components/toolbar/items';

import _ from 'underscore';
import $ from 'jquery';

@observer
class ExploreCompareOptions extends Component {

	constructor(props) {
		super(props);

		this.state = {
			open: false
		};
	}

	render() {
		const forwardedProps = _.omit(this.props, 'model');

		return (
			<div ref={node => this.domNode = node}>
				<CaretToolbarItem
					{...forwardedProps}
					label={StringResources.get('exploreToolbar_compare_options')}
					title={StringResources.get('exploreToolbar_compare_options')}
					selected={this.state.open}
					onPrimaryAction={(event) => this.onClick(event)}
				>
				</CaretToolbarItem>
				{this.renderContextMenu()}
			</div>
		);
	}

	renderContextMenu() {
		if (!this.state.open) {
			return;
		}
		const syncSelections = this.props.model.isWidgetSelectionsSynced();
		const syncCompareLine = this.props.model.isCompareLineEnabled() && this.props.model.isCompareLineSynced();
		const syncMatchScale = this.props.model.isScaleSynced();
		const syncActions = this.props.model.isActionsSynced();

		const checkboxContent = this.getCompareOptionsMenuItems();
		const selection = {
			toggleswitch: {
				syncSelections,
				syncCompareLine,
				syncMatchScale,
				syncActions
			}
		};

		const placement = 'bottomRight';

		return (
			<ContextMenu
				className='explore-compare-options__menu'
				theme={true}
				onClose={() => this.onClose()}
				domNodeToAttachTo={document.body}
				onChange={(...params) => this.onContextMenuChange(...params)}
				selected={selection}
				triggerNode={this.domNode}
				placement={placement}
				align='left'
			>
				<ContextMenu.ToggleSwitch
					content={checkboxContent}
					name='toggleswitch'
					label={StringResources.get('exploreToolbar_compare_options_menu_title')}
				/>
			</ContextMenu>
		);
	}

	isEnabled() {
		return this.props.enabled;
	}

	onClick(event) {
		// Check if the click originated from within the context menu, ignore it.
		if (this.isEnabled() && $(event.target).closest('.explore-compare-options__menu').length === 0) {
			this.setState({
				open: !this.state.open
			});
		}
	}

	onClose() {
		this.setState({
			open: false
		});
	}

	/**
	 * called when any of the toggle switch changes by the user
	 * @param {string} name - name of the control 'toggleSwitch'
	 * @param {object} selection - a map of selection eg. {syncSelections: true, syncCompareLine: false}
	 */
	onContextMenuChange(name, selection) {
		/* only set on compare model on the updated value */
		if (selection.syncSelections !== this.props.model.isWidgetSelectionsSynced()) {
			this.props.model.updateWidgetSelectionsSynced(selection.syncSelections);
		} else if (selection.syncCompareLine !== (this.props.model.isCompareLineEnabled() && this.props.model.isCompareLineSynced())) {
			this.props.model.setCompareLineSynced(selection.syncCompareLine);
		} else if (selection.syncMatchScale !== this.props.model.isScaleSynced()) {
			this.props.model.updateSyncAxisScale(selection.syncMatchScale, true /* isToggledByUser */);
		} else if (selection.syncActions !== this.props.model.isActionsSynced()) {
			this.props.model.setActionsSynced(selection.syncActions);
		}
	}

	/* Compare Options Context menu */

	getCompareOptionsMenuItems() { // these might have to fetch dynamically, until then...
		return [
			{
				label: StringResources.get('exploreToolbar_compare_options_menuItem_sync_selections'),
				value: 'syncSelections'
			},
			{
				label: StringResources.get('exploreToolbar_compare_options_menuItem_sync_compare_line'),
				value: 'syncCompareLine',
				/* the flag used in toolkit to disable a single menu item in a toggle menu group */
				disabledSingular: !this.props.model.isCompareLineEnabled()
			},
			{
				label: StringResources.get('exploreToolbar_compare_options_menuItem_sync_axis_scale'),
				value: 'syncMatchScale',
				/* the flag used in toolkit to disable a single menu item in a toggle menu group */
				disabledSingular: !this.props.model.isMatchScaleEnabled
			},
			{
				label: StringResources.get('exploreToolbar_compare_options_menuItem_sync_actions'),
				value: 'syncActions'
			}
		];
	}
}

ExploreCompareOptions.propTypes = {
	model: PropTypes.object,
	hidden: PropTypes.bool,
	enabled: PropTypes.bool,
	selected: PropTypes.bool
};

ExploreCompareOptions.defaultProps = {
	hidden: false,
	enabled: true,
	selected: false
};

export default ExploreCompareOptions;



// WEBPACK FOOTER //
// ./src/js/layout/explorecontainer/ExploreCompareOptions.js